export { default } from "~/components/product/ProductDescription/index"

// Os ids precisam existir no placeholder, antes do lazy load: "Ver descrição
// completa" aponta para #description e "Clique e veja!" para
// #konfidency-reviews (miess-01 #c30258). Fica AQUI, não re-exportado do
// componente — `export { LoadingFallback } from` é ponto cego do
// generate-sections (`hasLoadingFallback: false`, ver #51). 800px é a altura
// medida no #51, não os 700px do original.
export function LoadingFallback() {
  return (
    <div id='description' className='w-full min-h-[800px] bg-base-200/30 animate-pulse'>
      <div id='konfidency-reviews' />
    </div>
  )
}
